var _circle, _circle2, _circle3, _circle4, _circle5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomLoaderBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 521,
    height: 520,
    viewBox: "0 0 521 520",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 260.5,
    cy: 260,
    r: 99.6,
    stroke: "url(#paint0_linear_1416_4379)",
    strokeOpacity: 0.16,
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 260.5,
    cy: 260,
    r: 139.65,
    stroke: "url(#paint1_linear_1416_4379)",
    strokeOpacity: 0.16,
    strokeWidth: 0.7,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 260.5,
    cy: 260,
    r: 179.7,
    stroke: "url(#paint2_linear_1416_4379)",
    strokeOpacity: 0.26,
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 260.5,
    cy: 260,
    r: 219.75,
    stroke: "url(#paint3_linear_1416_4379)",
    strokeOpacity: 0.24,
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 260.5,
    cy: 260,
    r: 259.8,
    stroke: "url(#paint4_linear_1416_4379)",
    strokeOpacity: 0.24,
    strokeWidth: 0.4,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1416_4379",
    x1: 260.5,
    y1: 160,
    x2: 260.5,
    y2: 360,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C757D",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#6C757D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C757D",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1416_4379",
    x1: 260.5,
    y1: 120,
    x2: 260.5,
    y2: 400,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C757D",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#6C757D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C757D",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1416_4379",
    x1: 260.5,
    y1: 80,
    x2: 260.5,
    y2: 440,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C757D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#6C757D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C757D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1416_4379",
    x1: 260.5,
    y1: 40,
    x2: 260.5,
    y2: 480,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C757D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#6C757D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C757D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1416_4379",
    x1: 260.5,
    y1: 0,
    x2: 260.5,
    y2: 520,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C757D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#6C757D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C757D",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomLoaderBg);
export default __webpack_public_path__ + "static/media/custom-loader-bg.9db547bbcbfb7fdd8cc93f2f62be303b.svg";
export { ForwardRef as ReactComponent };